import React from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import { Title } from '../../../ui/Title';

const Wrapper = styled.div`
  padding-top: 158px;

  @media (max-width: 1035px) {
    padding-top: 64px;
  }
`;

const PageTitle = styled(Title)``;

const HeaderTitle: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <PageTitle>{t('tourist_insurance')}</PageTitle>
    </Wrapper>
  );
};

export default HeaderTitle;
